import {
  EClickableSize,
  EClickableVariants,
} from '../at-clickable/at-clickable.types';
import { IAtbuttonProps } from './at-button.types';

export const atButtonMockData: IAtbuttonProps = {
  label: 'Find Your Home',
  intent: EClickableVariants.PRIMARY,
  outline: false,
  size: EClickableSize.SM,
};
